import { createFileRoute, redirect, Link } from '@tanstack/react-router'
import { ShopCatalog } from '#bv/components/ShopCatalog'

function previewProductsEnabled() {
  return import.meta.env.DEV || import.meta.env.VITE_PREVIEW_PRODUCTS === 'true'
}

export const Route = createFileRoute('/preview/products')({
  beforeLoad: () => {
    if (!previewProductsEnabled()) {
      throw redirect({ to: '/' })
    }
  },
  component: PreviewProductsPage,
})

function PreviewProductsPage() {
  return (
    <div>
      <div
        className="border-b px-4 py-3 text-center text-sm font-medium sm:text-base"
        style={{
          background: 'linear-gradient(90deg, rgba(0, 191, 255,0.2), rgba(123,47,190,0.15))',
          borderColor: 'rgba(0,191,255,0.35)',
          color: '#f0f6ff',
        }}
      >
        <span className="inline-flex flex-wrap items-center justify-center gap-x-2 gap-y-1">
          <span className="rounded-md bg-black/30 px-2 py-0.5 text-xs font-bold tracking-wider text-[#93c5fd]">
            PREVIEW
          </span>
          <span style={{ color: '#8ecfff' }}>Not the live storefront — safe to review cards and photos.</span>
          <Link
            to="/shop"
            className="ml-1 shrink-0 rounded-lg px-2 py-1 text-xs font-semibold underline-offset-2 hover:underline sm:text-sm"
            style={{ color: '#fff' }}
          >
            Go to live shop â†’
          </Link>
        </span>
      </div>
      <ShopCatalog variant="preview" />
    </div>
  )
}
